<img [defaultImage]="defaultImage" [lazyLoad]="src" [class]="class" />
